module.exports = __webpack_public_path__ + "static/media/Logo.93604a30.png";